import React from "react";
import RoutesName from "variables/route";
import CompanyProfileSetup from "views/company_profile_setup/CompanyProfileSetup";
import PostShiftList from "components/PostShift";
import ShiftRequestsList from "components/ShiftRequests";
import LocumsList from "components/Locums";
import Dashboard from "views/Dashboard/Dashboard";
import BusinessUserProfile from "components/Profile";
import Messages from "components/Messages";
import Shifts from "components/Shifts";
import DashboardIcon from "./components/Sidebar/sideBarIcons/DashboardIcon";
import PostShiftsIcon from "./components/Sidebar/sideBarIcons/PostShiftsIcon";
import ShiftsIcon from "./components/Sidebar/sideBarIcons/ShiftsIcon";
import ShiftRequestIcon from "./components/Sidebar/sideBarIcons/ShiftRequestIcon";
import LocumsIcon from "./components/Sidebar/sideBarIcons/LocumsIcon";
import MessagesIcon from "./components/Sidebar/sideBarIcons/MessagesIcon";
import SettingsIcon from "./components/Sidebar/sideBarIcons/SettingsIcon";
import LocationsIcon from "./components/Sidebar/sideBarIcons/LocationsIcon";
import UsersIcon from "./components/Sidebar/sideBarIcons/UsersIcon";
import Help from "components/Help";
import HelpIcon from "./components/Sidebar/sideBarIcons/HelpIcon";
import Locations from "components/Location";
import Users from "components/Users";
import { USER_ROLE } from "variables/helper";

const {
    dashboard,
    company_profile_setup,
    post_shifts,
    shift_requests,
    locums,
    profile,
    messages,
    shifts,
    help,
    locations,
    users,
} = RoutesName;

export const sidebarRoutes = [
    {
        path: dashboard,
        name: "Overview",
        icon: DashboardIcon,
        component: <Dashboard />,
        inSidebar: true,
    },
    {
        path: post_shifts,
        name: "All Shifts",
        icon: PostShiftsIcon,
        component: <PostShiftList />,
        inSidebar: true,
    },
    {
        path: shifts,
        name: "Shift Responses",
        icon: ShiftsIcon,
        component: <Shifts />,
        inSidebar: true,
    },
    {
        path: shift_requests,
        name: "Active Requests",
        icon: ShiftRequestIcon,
        component: <ShiftRequestsList />,
        inSidebar: true,
    },
    {
        path: locums,
        name: "Contacts",
        icon: LocumsIcon,
        component: <LocumsList />,
        inSidebar: true,
    },
    {
        path: messages,
        name: "Messages",
        icon: MessagesIcon,
        component: <Messages />,
        inSidebar: true,
    },
    {
        path: help,
        name: "Help",
        icon: HelpIcon,
        component: <Help />,
        inSidebar: true,
    },
    {
        path: profile,
        name: "Your Profile",
        icon: SettingsIcon,
        component: <BusinessUserProfile />,
        inSidebar: true,
    },
    {
        path: locations,
        name: "Branch Locations",
        icon: LocationsIcon,
        component: <Locations />,
        inSidebar: true,
    },
    {
        path: users,
        name: "Account Users",
        icon: UsersIcon,
        component: <Users />,
        inSidebar: true,
    },
    {
        path: company_profile_setup,
        name: "Profile Setup",
        icon: "DashboardIcon",
        component: <CompanyProfileSetup />,
        inSidebar: false,
    },
];

export const sidebarRoutesForSubUser = [
    {
        path: post_shifts,
        name: "All Shifts",
        icon: PostShiftsIcon,
        component: <PostShiftList />,
        inSidebar: true,
    },
    {
        path: shifts,
        name: "Shift Responses",
        icon: ShiftsIcon,
        component: <Shifts />,
        inSidebar: true,
    },
    {
        path: shift_requests,
        name: "Active Requests",
        icon: ShiftRequestIcon,
        component: <ShiftRequestsList />,
        inSidebar: true,
    },
    {
        path: locums,
        name: "Contacts",
        icon: LocumsIcon,
        component: <LocumsList />,
        inSidebar: true,
    },
    {
        path: messages,
        name: "Messages",
        icon: MessagesIcon,
        component: <Messages />,
        inSidebar: true,
    },
];

const routes = [
    ...( await JSON.parse(localStorage.getItem("user"))?.role !== USER_ROLE.SUB_USER
        ? sidebarRoutes
        : sidebarRoutesForSubUser),
];

export default routes;
